/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface TitreDiplomeCertificationSearchDto
 */
export interface TitreDiplomeCertificationSearchDto {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof TitreDiplomeCertificationSearchDto
     */
    description?: UnaccentTextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof TitreDiplomeCertificationSearchDto
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof TitreDiplomeCertificationSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof TitreDiplomeCertificationSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof TitreDiplomeCertificationSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TitreDiplomeCertificationSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TitreDiplomeCertificationSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TitreDiplomeCertificationSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the TitreDiplomeCertificationSearchDto interface.
 */
export function instanceOfTitreDiplomeCertificationSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TitreDiplomeCertificationSearchDtoFromJSON(json: any): TitreDiplomeCertificationSearchDto {
    return TitreDiplomeCertificationSearchDtoFromJSONTyped(json, false);
}

export function TitreDiplomeCertificationSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TitreDiplomeCertificationSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : UnaccentTextSearchFromJSON(json['description']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function TitreDiplomeCertificationSearchDtoToJSON(value?: TitreDiplomeCertificationSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': UnaccentTextSearchToJSON(value.description),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

